module.exports = __webpack_public_path__ + "img/grid-3x3-gap-fill.4206ee67.svg";